// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"458":"e72b1c46","867":"1ec395ac"}[chunkId] + ".chunk.css";
};